import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Redirect, useHistory } from "react-router-dom";
import BlankLayout from "go-core/components/Layout/BlankLayout";

const SecurityEmailConfirmedPage = () => {
	const { t } = useTranslation();
	const history = useHistory();

	useEffect(() => {
		setTimeout(() => {
			history.push("/dashboard");
		}, 3000);
	}, []);

	if (document.referrer === "") {
		return <Redirect to={"/dashboard"} />;
	}

	return (
		<BlankLayout>
			<div className="container-center">
				<div className="d-flex" style={{ flexDirection: "column" }}>
					<img className="logo-img" alt="GoPOS Logo" src="/graphics/goaccounts-logo-b.svg" />
					<h2>
						<div className="spinner-border" />
						{t("modules.security.field.email_confirmed.title")}
					</h2>
				</div>
			</div>
		</BlankLayout>
	);
};
export default SecurityEmailConfirmedPage;
